import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-duration-days-field',
  templateUrl: './gelios-duration-days-field.component.html',
})
export class GeliosDurationDaysFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
